<template>
    <div class="product-carousel" v-if="carouselItems && carouselItems.length">
      <el-card class="product-card">
        <h1 class="center">推荐产品</h1><br/>
        <div class="product-wrapper">
          <div class="product-info" v-for="item in carouselItems"
               :key="item.id"
               @click="viewDetails(item.id)"
          >
            <el-image
                :src="item.mainImage"
                fit="fill"  @error="handleImageError" />
            <div class="product-name">
              {{ item.name }}
            </div>
<!--            <p>¥{{ item.price }}元</p>-->
          </div>
        </div>
      </el-card>
    </div>
  </template>

  <script>
  import {getAllProducts, getProductCarouselById} from '@/api/index'; // 从 index.js 导入 getProducts 函数

  export default {
    name: 'ProductCarousel',
    data() {
      return {
        products: [],
        carouselItems: []
      };
    },
    mounted() {
      this.fetchProducts();
    },
    methods: {
      async fetchProducts() {
        try {
          const response = await getAllProducts();
          if (response.code === 0) {
            this.products = response.data;
          } else {
            this.$message.error('获取产品数据失败: ' + response.message);
          }
          await this.fetchCarouselConfig();
        } catch (error) {
          console.error('获取产品数据失败:', error);
          this.$message.error('获取产品数据失败');
        }
      },
      async fetchCarouselConfig() {
        // 获取横向产品列表
        const response = await getProductCarouselById(1);
        if(response.data){
          let array = response.data.products || [];
          for(let i in array) {
            const product = this.products.find(product => product.id === array[i]);
            this.carouselItems.push(product);
          }
        }
      },
      viewDetails(id) {
        this.$router.push({ name: 'ProductDetail', params: { id } });
      },
      handleImageError(event) {
        console.error('图片加载失败:', event.target.src);
      }
    }
  };
  </script>

  <style lang="scss" scoped>
.product-carousel {
  .product-card {
    margin-top: 20px;
    margin-bottom: 20px;
    height: unset;
    padding: 10px;

    .product-wrapper{
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
    }
  }

  .product-info {
    width: 300px;
    align-self: stretch;
    justify-self: center;
    cursor: pointer;
    text-align: center;

    .el-image {
      width: 100%;
      height: 300px;
    }

    .product-name {
      width: 100%;
      overflow-x: hidden;
      text-wrap: nowrap;
      text-overflow: ellipsis;
      font-size: 1.2em;
      font-weight: bold;
    }
    p {
      font-size: 1em;
      color: red;
      font-weight: bold
    }
  }

  @media (max-width: 768px) {
    .product-card {
      padding: 5px;
      height: unset;
    }
    .product-info {
      width: 100%;

      .el-image {
        width: 100%;
        height: 300px;
      }

      .product-name {
        text-wrap: wrap;
        font-size: 1em;
      }

      p {
        font-size: 0.8em;
      }
    }
  }

  @media (max-width: 480px) {
    .product-card {
      padding: 5px;
      height: unset;
    }
    .product-info {
      width: 100%;

      .el-image {
        width: 100%;
        height: 300px;
      }

      .product-name {
        text-wrap: wrap;
        font-size: 1em;
      }

      p {
        font-size: 0.8em;
      }
    }
  }
}
</style>
